export default {
  colors: {
    text: '#111',
    background: '#111',
  },
}